(function() {
  'use strict';
  
  let currentVariant = window.__currentVariant?.title;
  let tabStructure = {}; 
  let allTabNames = new Set(); 

  function updateVariantTabs(variantId) {
    console.log('Switching to variant:', variantId);
    
    document.querySelectorAll('.variant-tabs-container').forEach(container => {
      container.style.display = 'none';
    });
    
    document.querySelectorAll(`.variant-tabs-container[data-variant-id="${variantId}"]`).forEach(container => {
      container.style.display = 'block';
    });
  }

  // Get current variant metafields
  // const getCurrentVariantMetafields = () => {
  //   // First try to get from current variant object
  //   if (window.__currentVariant && window.__currentVariant.metafields) {
  //     return window.__currentVariant.metafields;
  //   }
    
  //   // Try to find variant by title in product variants
  //   if (window.product && window.product.variants && currentVariant) {
  //     const variant = window.product.variants.find(v => v.title === currentVariant);
  //     if (variant && variant.metafields) {
  //       return variant.metafields;
  //     }
  //   }
    
  //   return null;
  // };

  // Process icons from variant metafields
  // const processIngredientIcons = () => {
  //   if (!window.product || !window.product.variants || !currentVariant) {
  //     return '';
  //   }
    
  //   // Find current variant data
  //   const variant = window.product.variants.find(v => v.title === currentVariant);
  //   if (!variant || !variant.metafields || !variant.metafields.custom) {
  //     console.log('No metafields found for variant:', currentVariant);
  //     return '';
  //   }
    
  //   const metafields = variant.metafields.custom;
    
  //   // Check for variant icons metafield
  //   if (metafields.variant_icons) {
  //     const iconObjects = metafields.variant_icons.value || [];
      
  //     if (Array.isArray(iconObjects) && iconObjects.length > 0) {
  //       let iconHTML = '<div class="accordion-variant-icons">';
        
  //       iconObjects.forEach(iconObj => {
  //         if (iconObj.icon && iconObj.label) {
  //           const iconUrl = iconObj.icon;
            
  //           iconHTML += `
  //             <div class="variant-icon-item">
  //               <div class="variant-icon-image">
  //                 <img src="${iconUrl}" alt="${iconObj.label}" width="24" height="24">
  //               </div>
  //               <span class="variant-icon-text">${iconObj.label}</span>
  //             </div>
  //           `;
  //         }
  //       });
        
  //       iconHTML += '</div>';
  //       console.log('Generated variant icons for:', currentVariant, 'Icons:', iconObjects.length);
  //       return iconHTML;
  //     }
  //   }
    
  //   console.log('No icons found for variant:', currentVariant);
  //   return '';
  // };

  // Process embedded variant icons from description content
  // const processVariantIcons = (content) => {
  //   // Process <variant-icons> blocks within tab content
  //   const variantIconsRegex = /&lt;variant-icons&gt;([\s\S]*?)&lt;\/variant-icons&gt;/g;
  //   const iconRegex = /&lt;icon label="(.+?)" file="(.+?)" \/&gt;/g;
    
  //   let processedContent = content;
    
  //   const variantIconsMatch = processedContent.match(variantIconsRegex);
  //   if (variantIconsMatch) {
  //     variantIconsMatch.forEach(iconsBlock => {
  //       let iconHTML = '<div class="accordion-variant-icons">';
        
  //       const iconMatches = iconsBlock.matchAll(iconRegex);
  //       for (const iconMatch of iconMatches) {
  //         const label = iconMatch[1];
  //         const filename = iconMatch[2];
          
  //         // Get the icon URL from pre-loaded asset URLs
  //         const iconUrl = window.iconAssets && window.iconAssets[filename] 
  //           ? window.iconAssets[filename] 
  //           : `/assets/${filename}`;
          
  //         iconHTML += `
  //           <div class="variant-icon-item">
  //             <div class="variant-icon-image">
  //               <img src="${iconUrl}" alt="${label}" width="24" height="24">
  //             </div>
  //             <span class="variant-icon-text">${label}</span>
  //           </div>
  //         `;
  //       }
        
  //       iconHTML += '</div>';
        
  //       // Replace the entire <variant-icons> block with the generated HTML
  //       processedContent = processedContent.replace(iconsBlock, iconHTML);
  //     });
  //   }
    
  //   return processedContent;
  // };

  const showCurrentVariantDescription = (scope) => {
    const root = (scope && scope.querySelectorAll) ? scope : document;
    const $variantDescriptions = root.querySelectorAll(`[data-variant-description]`);
    
    $variantDescriptions.forEach((el) => {
      if (el.dataset.variantDescription === currentVariant) {
        el.classList.add('visible');
      } else {
        el.classList.remove('visible');
      }
    });
  };

  // Update tab content for current variant
  // const showCurrentVariantTab = () => {
  //   if (!currentVariant || !tabStructure[currentVariant]) {
  //     allTabNames.forEach(tabName => {
  //       const $tabWrapper = document.querySelector(`[data-dynamic-tab="${tabName}"]`);
  //       if ($tabWrapper) $tabWrapper.style.display = 'none';
  //     });
  //     return;
  //   }

  //   // Update each tab's content and visibility
  //   allTabNames.forEach((tabName, index) => {
  //     const $tabContent = document.querySelector(`[data-dynamic-tab="${tabName}"] .collapsible-content__inner`);
  //     const $tabWrapper = document.querySelector(`[data-dynamic-tab="${tabName}"]`);
      
  //     if ($tabContent && $tabWrapper) {
  //       const variantTabContent = tabStructure[currentVariant][tabName];
        
  //       if (variantTabContent) {
  //         let processedContent = variantTabContent;
          
  //         // Process embedded variant icons first
  //         processedContent = processVariantIcons(processedContent);
          
  //         // SPECIAL: Add metafield icons to INGREDIENTS tab
  //         if (tabName === 'INGREDIENTS') {
  //           const metafieldIcons = processIngredientIcons();
  //           if (metafieldIcons) {
  //             processedContent += metafieldIcons;
  //           }
  //         }
          
  //         // Legacy placeholder support
  //         if (processedContent.includes('') || processedContent.includes('')) {
  //           const iconHTML = processIngredientIcons();
  //           processedContent = processedContent.replace(/\{\{(variant_icons|ingredient_icons)\}\}/g, iconHTML);
  //         }
          
  //         $tabContent.innerHTML = `<div class="accordion-ingredient-list">${processedContent}</div>`;
  //         $tabWrapper.style.display = 'block';
          
  //         // Update accordion classes
  //         const allTabsArray = Array.from(allTabNames);
  //         const isFirst = index === 0;
  //         const isLast = index === allTabsArray.length - 1;
          
  //         $tabWrapper.classList.remove('accordion-item--first', 'accordion-item--last');
  //         if (isFirst) $tabWrapper.classList.add('accordion-item--first');
  //         if (isLast) $tabWrapper.classList.add('accordion-item--last');
          
  //       } else {
  //         $tabWrapper.style.display = 'none';
  //       }
  //     }
  //   });
  // };

  const processDescriptionContent = (scope) => {
    const $productDescription = (scope && scope.querySelector) ? scope.querySelector('.product-main-description') : document.querySelector('.product-main-description');
    if (!$productDescription) return;

    const variantDescriptionRegex = /&lt;variant-description name="(.+?)"&gt;([\s\S]*?)&lt;\/variant-description&gt;/g;
    const matches = $productDescription.innerHTML.matchAll(variantDescriptionRegex);
    
    for (const match of matches) {
      const variantName = match[1];
      const description = match[2];
      console.log('Found variant:', variantName);
      const $variantDescription = document.createElement('div');
      $variantDescription.setAttribute('data-variant-description', variantName);
      $variantDescription.innerHTML = description;
      $productDescription.innerHTML = $productDescription.innerHTML.replace(match[0], $variantDescription.outerHTML);
    }

    // Extract tab content from each variant description
    const root = (scope && scope.querySelectorAll) ? scope : document;
    const $variantDescriptions = root.querySelectorAll('[data-variant-description]');
    const tabContentRegex = /&lt;tab-content name="(.+?)"&gt;([\s\S]*?)&lt;\/tab-content&gt;/g;
    
    $variantDescriptions.forEach($variantDescription => {
      const variantName = $variantDescription.getAttribute('data-variant-description');
      
      if (!tabStructure[variantName]) {
        tabStructure[variantName] = {};
      }
      
      const matches = $variantDescription.innerHTML.matchAll(tabContentRegex);
      for (const match of matches) {
        const tabName = match[1];
        const tabContent = match[2];
        
        console.log('Found tab:', tabName, 'for variant:', variantName);
        
        // Store tab content for this variant
        tabStructure[variantName][tabName] = tabContent;
        
        // Add tab name to our set of all tab names
        allTabNames.add(tabName);
        
        // Remove the tab-content from the description
        $variantDescription.innerHTML = $variantDescription.innerHTML.replace(match[0], '');
      }
    });

    console.log('Tab structure:', tabStructure);
    console.log('All tab names:', Array.from(allTabNames));

    // Clean up empty elements
    let $emptyElements = $productDescription.querySelectorAll(':empty:not(br)');
    while ($emptyElements.length > 0) {
      $emptyElements.forEach($emptyElement => {
        $emptyElement.remove();
      });
      $emptyElements = $productDescription.querySelectorAll(':empty:not(br)');
    }

    showCurrentVariantDescription(scope);
    $productDescription.classList.add('visible');
  };

  // Create tab HTML structure matching your accordion pattern
  // const createTabsHTML = () => {
  //   if (!$dynamicTabsContainer || allTabNames.size === 0) {
  //     console.log('Cannot create tabs - no container or no tab names');
  //     return;
  //   }

  //   console.log('Creating tabs for:', Array.from(allTabNames));

  //   let tabsHTML = '';
  //   const allTabsArray = Array.from(allTabNames);
    
  //   allTabsArray.forEach((tabName, index) => {
  //     const isFirst = index === 0;
  //     const isLast = index === allTabsArray.length - 1;
      
  //     tabsHTML += `
  //       <div
  //         x-data="{ 
  //           isOpen: false,
  //           toggle() {
  //             this.isOpen = !this.isOpen;
  //           }
  //         }"
  //         class="accordion-item ${isFirst ? 'accordion-item--first' : ''} ${isLast ? 'accordion-item--last' : ''}"
  //         data-dynamic-tab="${tabName}"
  //       >
  //         <button
  //           type="button"
  //           class="accordion-trigger"
  //           @click="toggle"
  //           :aria-expanded="isOpen"
  //         >
  //           <div class="accordion-trigger__inner">
  //             <div class="accordion-trigger__content">
  //               <div class="accordion-item-title">
  //                 ${tabName.toUpperCase()}
  //               </div>
  //             </div>
              
  //             <span class="accordion-icon" :class="isOpen ? 'accordion-icon--open' : ''">
  //               <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
  //                 <path d="M10 4.16667V15.8333" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
  //                 <path d="M4.16669 10H15.8334" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
  //               </svg>
  //             </span>
  //           </div>
  //         </button>
          
  //         <div
  //           x-show="isOpen"
  //           x-transition:enter="accordion-enter"
  //           x-transition:enter-start="accordion-enter-start"
  //           x-transition:enter-end="accordion-enter-end"
  //           x-transition:leave="accordion-leave"
  //           x-transition:leave-start="accordion-leave-start"
  //           x-transition:leave-end="accordion-leave-end"
  //           class="accordion-content"
  //         >
  //           <div class="collapsible-content__inner">
  //             <!-- Content will be populated by showCurrentVariantTab -->
  //           </div>
  //         </div>
  //       </div>
  //     `;
  //   });
    
  //   $dynamicTabsContainer.innerHTML = tabsHTML;
  //   console.log('Tabs HTML inserted');

  //   // Initialize Alpine.js for the new elements
  //   if (window.Alpine) {
  //     window.Alpine.initTree($dynamicTabsContainer);
  //     console.log('Alpine.js initialized for new tabs');
  //   }

  //   // Show content for current variant
  //   showCurrentVariantTab();
  // };

  const initialize = (scope) => {
    processDescriptionContent(scope);
  //  createTabsHTML();
  };

  function syncVariantInputs(container, variant) {
    if (!container || !variant || !variant.id) return;

    container.querySelectorAll('[name="id"]').forEach(function (input) {
      input.value = variant.id;
    });
  }

  function getColorInputsFromSection(section) {
    if (!section) return [];

    const swatches = section.querySelectorAll('.variant__input--color-swatch');
    if (swatches.length) return Array.from(swatches);

    const colorWrap = section.querySelector(
      '.variant-input-wrap[data-handle="color"], .variant-input-wrap[data-handle="colour"], .variant-input-wrap[data-handle="shade"]'
    ) || section.querySelector(
      '.variant-input-wrap[data-handle*="color"], .variant-input-wrap[data-handle*="colour"]'
    );

    if (!colorWrap) return [];

    const input = colorWrap.querySelector('[data-variant-input]');
    return input ? [input] : [];
  }

  function getSelectedColorFromSection(section) {
    const colorInputs = getColorInputsFromSection(section);
    if (!colorInputs.length) return null;

    const input = colorInputs[0];
    if (input.tagName === 'SELECT') {
      return input.value || null;
    }

    const checked = colorInputs.find(function (el) {
      return el.checked;
    });

    return checked ? checked.value : null;
  }

  function applyPreferredColorToSection(section, preferredColor) {
    const colorInputs = getColorInputsFromSection(section);
    if (!colorInputs.length || !preferredColor) return null;

    const firstInput = colorInputs[0];

    if (firstInput.tagName === 'SELECT') {
      const options = Array.from(firstInput.options).map(function (option) {
        return option.value;
      });
      const nextColor = options.indexOf(preferredColor) !== -1
        ? preferredColor
        : options[0];

      if (!nextColor) return null;

      if (firstInput.value !== nextColor) {
        firstInput.value = nextColor;
      }

      firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      return nextColor;
    }

    let targetInput = colorInputs.find(function (input) {
      return input.value === preferredColor;
    });

    if (!targetInput) {
      targetInput = colorInputs[0];
    }

    if (!targetInput.checked) {
      targetInput.checked = true;
    }

    targetInput.dispatchEvent(new Event('change', { bubbles: true }));
    return targetInput.value;
  }

  function getColorVariantWrapper(section) {
    if (!section) return null;

    const swatch = section.querySelector('.variant__input--color-swatch');
    return swatch ? swatch.closest('.variant-wrapper') : null;
  }

  function setColorSelectionPending(section, pending) {
    const wrapper = getColorVariantWrapper(section);
    if (!wrapper) return;
    wrapper.classList.toggle('is-color-pending', pending);
  }

  function revealColorSelection(section, delay) {
    window.setTimeout(function () {
      setColorSelectionPending(section, false);
    }, delay || 120);
  }

  window.getSelectedColorFromSection = getSelectedColorFromSection;
  window.applyPreferredColorToSection = applyPreferredColorToSection;
  window.setColorSelectionPending = setColorSelectionPending;
  window.revealColorSelection = revealColorSelection;

  function getVariantFromSection(container) {
    if (!container) return null;

    const currentVariantJson = container.querySelector('[data-current-variant-json]');
    if (currentVariantJson && currentVariantJson.textContent.trim()) {
      try {
        return JSON.parse(currentVariantJson.textContent);
      } catch (error) {
        console.warn('Kunde inte läsa current variant JSON', error);
      }
    }

    const variantSelect = container.querySelector('[data-product-select]');
    const variantsJson = container.querySelector('[data-variant-json]');

    if (variantSelect && variantsJson && variantsJson.textContent.trim()) {
      try {
        const variants = JSON.parse(variantsJson.textContent);
        return variants.find(function (variant) {
          return String(variant.id) === String(variantSelect.value);
        }) || null;
      } catch (error) {
        console.warn('Kunde inte läsa variant JSON', error);
      }
    }

    return window.__currentVariant || null;
  }

  window.syncProductSectionVariant = function (container, options) {
    const variant = getVariantFromSection(container);
    if (!variant) return;

    window.__currentVariant = variant;
    syncVariantInputs(container, variant);

    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: {
        variant: variant,
        fromSizeVersion: !!(options && options.fromSizeVersion)
      }
    }));
  };

  function bindVariantSync(container) {
    if (!container || container.dataset.variantSyncBound === 'true') return;

    container.dataset.variantSyncBound = 'true';
    container.addEventListener('variantChange', function (event) {
      if (event.detail && event.detail.variant) {
        window.__currentVariant = event.detail.variant;
        syncVariantInputs(container, event.detail.variant);
      }
    });
  }

  window.initProductVariantSync = function (scope) {
    const root = scope || document;
    const sections = [];

    if (root.matches && root.matches('[data-product-section]')) {
      sections.push(root);
    }

    root.querySelectorAll('[data-product-section]').forEach(function (section) {
      if (!sections.includes(section)) {
        sections.push(section);
      }
    });

    sections.forEach(function (section) {
      delete section.dataset.variantSyncBound;
      bindVariantSync(section);
    });
  };

  window.initProductCustom = function(productSection) {
    if (!productSection) return;
    currentVariant = window.__currentVariant ? window.__currentVariant.title : null;
    tabStructure = {};
    allTabNames = new Set();
    initialize(productSection);
    window.initProductVariantSync(productSection);
  };

  document.addEventListener('alpine:init', () => {
    initialize();
    window.initProductVariantSync();
  });

  if (window.Alpine) {
    initialize();
    window.initProductVariantSync();
  }

  setTimeout(() => {
    const $desc = document.querySelector('.product-main-description');
    if ($desc && !$desc.classList.contains('visible') && allTabNames.size === 0) {
      initialize();
    }
  }, 1000);

  const handleVariantChange = (newVariant) => {
    currentVariant = newVariant;
    showCurrentVariantDescription();
  };

  document.addEventListener('click', (e) => {
    if (e.target.matches('.variant-input[data-value]')) {
      const newVariant = e.target.dataset.value;
      handleVariantChange(newVariant);
    }
  });

  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      handleVariantChange(e.detail.variant.title);
    }
  });

  function updateKlaviyoBisVisibility(available) {
    const bisContainer = document.getElementById('klaviyo-bis-button-container');
    if (!bisContainer) return;
    bisContainer.style.display = available ? 'none' : 'block';
  }

  function getMainProductCta() {
    return document.querySelector('[data-product-cta]:not([data-sticky-cta])');
  }

  function getStickyProductCta() {
    return document.querySelector('[data-sticky-cta]');
  }

  function isStickyBarVisible() {
    const container = document.querySelector('.sticky-add-to-cart-container');
    if (!container) return false;
    return window.getComputedStyle(container).display !== 'none';
  }

  function syncKlaviyoBisPlacement(available, stickyVisible) {
    const bisContainer = document.getElementById('klaviyo-bis-button-container');
    if (!bisContainer) return;

    if (available === undefined) {
      const mainCta = getMainProductCta();
      available = mainCta ? !mainCta.classList.contains('product-cta--oos') : true;
    }

    const stickyCta = getStickyProductCta();
    const mainCta = getMainProductCta();
    const isSticky = stickyVisible !== undefined ? stickyVisible : isStickyBarVisible();
    const useSticky = available === false && isSticky && stickyCta;
    const target = useSticky ? stickyCta : mainCta;

    if (target && bisContainer.parentElement !== target) {
      target.appendChild(bisContainer);
    }
  }

  function updateProductCta(cta, available) {
    if (!cta) return;
    cta.classList.toggle('product-cta--oos', !available);
  }

  function syncProductCtas(variant, form) {
    const ctas = form
      ? [form.querySelector('[data-product-cta]')].filter(Boolean)
      : Array.from(document.querySelectorAll('[data-product-cta]'));

    let available;

    if (variant && typeof variant.available === 'boolean') {
      available = variant.available;
    }

    ctas.forEach(function(cta) {
      if (available === undefined) {
        const addToCartButton = cta.querySelector('[data-add-to-cart]');
        available = addToCartButton && !addToCartButton.disabled;
      }
      updateProductCta(cta, available);
    });

    if (available === undefined) {
      available = true;
    }

    updateKlaviyoBisVisibility(available);
    syncKlaviyoBisPlacement(available);
  }

  function observeKlaviyoBisContainer() {
    if (window._klaviyoBisObserver) return;

    const observer = new MutationObserver(function() {
      if (document.getElementById('klaviyo-bis-button-container')) {
        syncProductCtas();
        syncKlaviyoBisPlacement();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window._klaviyoBisObserver = observer;
  }

  function observeAddToCartButtons() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function(button) {
      const cta = button.closest('[data-product-cta]');
      if (!cta || button._ctaObserver) return;

      const observer = new MutationObserver(function() {
        updateProductCta(cta, !button.disabled);
        updateKlaviyoBisVisibility(!button.disabled);
        syncKlaviyoBisPlacement(!button.disabled);
      });

      observer.observe(button, { attributes: true, attributeFilter: ['disabled'] });
      button._ctaObserver = observer;
    });
  }

  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      syncProductCtas(e.detail.variant);
    }
  });

  document.addEventListener('variantChange', function(e) {
    const variant = e.detail && e.detail.variant;
    if (variant) syncProductCtas(variant);
  });

  document.addEventListener('change', function(e) {
    if (!e.target.matches('[data-product-select]')) return;

    const form = e.target.closest('form');
    const variantJson = form && form.querySelector('[data-variant-json]');
    if (!variantJson) return;

    try {
      const variants = JSON.parse(variantJson.textContent);
      const variant = variants.find(function(v) {
        return String(v.id) === String(e.target.value);
      });
      if (variant) syncProductCtas(variant);
    } catch (error) {}
  });

  document.addEventListener('sticky:change', function(e) {
    const stickyVisible = e.detail && e.detail.visible;
    const mainCta = getMainProductCta();
    const available = mainCta ? !mainCta.classList.contains('product-cta--oos') : true;

    requestAnimationFrame(function() {
      syncKlaviyoBisPlacement(available, stickyVisible);
      updateKlaviyoBisVisibility(available);
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    observeAddToCartButtons();
    observeKlaviyoBisContainer();
    syncProductCtas();
    console.log('Variant tab switcher initialized');
    window.initProductVariantSync();
    
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('change', function() {
        const variantInput = productForm.querySelector('[name="id"]');
        if (variantInput && variantInput.value) {
          updateVariantTabs(variantInput.value);
        }
      });
    }
    
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        updateVariantTabs(e.detail.variant.id);
      }
    });
    
    console.log('Variant containers found:', document.querySelectorAll('.variant-tabs-container').length);
    document.querySelectorAll('.variant-tabs-container').forEach(container => {
      console.log('Container for variant:', container.dataset.variantId, 'Display:', container.style.display);
    });
  });
})();


